import { cn } from "~/lib/utils";

interface KbdProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Kbd - Keyboard shortcut display component
 *
 * Displays keyboard shortcuts in a styled box with light/dark mode support.
 * Commonly used in tooltips and help text to indicate keyboard shortcuts.
 *
 * @example
 * <Kbd>/</Kbd>
 * <Kbd>⌘K</Kbd>
 * <Kbd className="text-lg">Enter</Kbd>
 */
export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={cn(
        "px-1.5 py-0.5 text-xs font-mono rounded shrink-0",
        "bg-gray-800 border border-gray-600 text-gray-100",
        className
      )}
    >
      {children}
    </kbd>
  );
}
